export default "__VITE_ASSET__Cely7SDk__"